import React from "react";
import { CardHeader } from "shards-react";
import {
  formatAddress,
  formatDateYearMonthDay,
  formatResident,
} from "../../utils/formatting";
import styles from "./card.module.scss";

/* @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { useNavigate } from "react-router-dom";

function UnfiledAcceptedCases({ unfiledAcceptedCases }) {
  const navigate = useNavigate();

  return (
    <div css={css``}>
      <CardHeader className="border-bottom">
        <h6 className="m-0">Unfiled Accepted Cases</h6>
      </CardHeader>
      <div className="p-3">
        <table className="w-100">
          <thead>
            <tr>
              <th>Date Created</th>
              <th>Management Organization</th>
              <th>Resident</th>
              <th>Address</th>
            </tr>
          </thead>
          <tbody>
            {unfiledAcceptedCases.map((caseItem) => {
              return (
                <tr
                  key={caseItem.id}
                  className={styles["card-item"]}
                  onClick={() => {
                    navigate(
                      `/cases/${caseItem.id}/${caseItem.organization_id}`
                    );
                  }}
                >
                  <td>{formatDateYearMonthDay(caseItem.created_at)}</td>
                  <td>{caseItem.organization.name}</td>
                  <td>{formatResident(caseItem)}</td>
                  <td>{formatAddress(caseItem)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <br />
        {!unfiledAcceptedCases.length && <span>No cases.</span>}
      </div>
    </div>
  );
}

export default UnfiledAcceptedCases;
